import Link from "@/modules/LinkOrcamento/Index.vue";

export default [
  {
    path: "/orcamento/:uuid",
    name: "orcamento/:uuid",
    component: Link,
    meta: { title: "Orçamento Digital" },
  },
];
